import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";

export const PageMeta = ({
    title,
    children,
    removeDescriptionTag,
    useSocialMediaTags,
    previewImg,
    description,
    twitterTitle,
    twitterCardContent,
    previewImgAlt,
    noindex,
    socialMediaDescription
}) => {
    useEffect(() => {
        if (removeDescriptionTag) {
            // We need to remove current meta description tag, not the one created by Helmet
            const currentDescriptionTag = document.querySelector(
                `meta[name="description"]:not([data-react-helmet="true"])`
            );

            if (currentDescriptionTag) {
                document.head.removeChild(currentDescriptionTag);
            }
        }
    }, [removeDescriptionTag]);

    return useSocialMediaTags ? (
        <Helmet>
            <title>{title}</title>
            {children}

            {/* if we don't want to index, pass noindex prop */}
            {noindex && <meta name="robots" content="noindex" />}
            {/* Facebook Meta tags */}
            <meta property="og:image" content={`${previewImg}`} />
            <meta property="og:title" content={`${title}`} />
            <meta property="og:description" content={description} />
            <meta property="og:site_name" content="The Noun Project" />
            <meta property="og:type" content="website" />

            {/* Twitter meta tags */}
            <meta
                name="twitter:card"
                content={twitterCardContent ? twitterCardContent : "summary"}
            />
            <meta name="twitter:site" content="@nounproject" />
            <meta
                name="twitter:title"
                content={`${twitterTitle ? twitterTitle : title}`}
            />
            <meta
                name="twitter:description"
                content={
                    socialMediaDescription
                        ? socialMediaDescription
                        : description
                }
            />
            <meta name="twitter:image:src" content={`${previewImg}`} />
            <meta name="twitter:image:alt" content={`${previewImgAlt}`} />
            <meta name="twitter:domain" content="https://thenounproject.com" />
        </Helmet>
    ) : (
        <Helmet>
            <title>{title}</title>
            {children}
            {/* if we don't want to index, pass noindex prop */}
            {noindex && <meta name="robots" content="noindex" />}
        </Helmet>
    );
};

PageMeta.propTypes = {
    title: PropTypes.string.isRequired,
    removeDescriptionTag: PropTypes.bool,
    useSocialMediaTags: PropTypes.bool,
    noindex: PropTypes.bool,
    previewImg: PropTypes.string,
    description: PropTypes.string,
    twitterTitle: PropTypes.string,
    twitterCardContent: PropTypes.string,
    socialMediaDescription: PropTypes.string,
    children: PropTypes.any
};

export default PageMeta;
